(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.service:ChampionshipTeamsPublic
   *
   * @description
   *
   */
  angular
    .module('neo.services')
    .service('ChampionshipTeamsPublic', ChampionshipTeamsPublic);

  function ChampionshipTeamsPublic($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/public/championships/:id/teams', {id: '@id'});
  }
}());
